/**
 * CustomerERP — Yedekleme (Faz 0). Mevcut şifreli yedekleme bileşeni
 * (System.jsx > BackupSettings) yeniden kullanılır. Dosya depolama
 * yapılandırılmadıysa yedek oluşturma STORAGE_NOT_CONFIGURED döner.
 */
import React from "react";
import { PageHeader } from "@/components/UI";
import { BackupSettings } from "@/pages/System";

export default function BackupPage() {
  return (
    <div data-testid="backup-page">
      <PageHeader title="Yedekleme" description="Şifreli veritabanı yedekleri" />
      <BackupSettings />
    </div>
  );
}
